import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactApexChart from "react-apexcharts";
import {
  IconBell,
  IconCash,
  IconCheck,
  IconClock,
  IconCoin,
  IconMoneybag,
  IconPhone,
  IconReportMoney,
  IconUser,
  IconUsersGroup,
} from "@tabler/icons-react";
import {
  avatar1,
  avatar2,
  avatar3,
  avatar4,
  avatar6,
} from "../../assets/images";
import {
  getAllEmployee,
  getAttendenceData,
  getdutywithdate,
  getEmployee,
  getLeaveGraph,
  GetNoOfLeaveWithDate,
  getPayrollDetails,
  getProfitCenter,
  getServiceRequest,
  GetTotalHeadCount,
} from "../../services/dataService";
import toast from "react-hot-toast";
import { Await, Link, Navigate, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { tempEndContract, tempLateEmp } from "../../atom/atom";
import { getSecureItem } from "../../services/SecureStorage";

export default function Dashboard() {
  const [leaveData, setLeaveData] = useState([]); // State to store the API response
  const [loading, setLoading] = useState(true);
  const [dutyassignedemployee, setdutyassignedemployee] = useState([]);
  const [employeelist, setemployeelist] = useState([]);
  const [headcount, setheadcount] = useState([]);
  const [lateEmployees, setLateEmployees] = useState([])
  const [endContract, setEndContract] = useState([])
  const [attendancedata, setattendancedata] = useState([]);
  const [YesterDayattendancedata, setYesterDayattendancedata] = useState([])// for the pending count 
  const [toDayAttenndanceData, setToDayAttenndanceData] = useState([])// for the pending count 

  const [MobilePunch, setMobilePunch] = useState([])// for the pending count 
   const [NoPunchApproved,setNoPunchApproved]=useState([])
  const [LeveGraph, setLeaveGraph] = useState([])
  const [notPunch, setNotPunch] = useState([])
  const [CommonDatas, setCommonDatas] = useState([])
  const [PayrollData, setPayrollData] = useState([])
  const [employee, setEmployee] = useState([]);
  const [lastProcess, setLastProcess] = useState([])
  const UID = getSecureItem("userId");
  const departmentIds = getSecureItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const DepId = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found
  const isAdmin = getSecureItem("IsAdmin");
  const [lateEmp, setLateEmp] = useRecoilState(tempLateEmp)
  const [contract, setContract] = useRecoilState(tempEndContract)
  const [HeadCountData, setHeadCountData] = useState([])
  const [NotWorkingEmployees, setNotWorkingEmployees] = useState([])
  const [allServices, setAllServices] = useState([]);


  useEffect(() => {
    const currentDate = new Date().toISOString(); // Get the current date in ISO format
    const payload = { Date: currentDate, UserId: UID }; // Create the payload with the current date
    // Function to fetch leave data
    const fetchLeaveData = async () => {
      try {
        const response = await GetNoOfLeaveWithDate(payload);
        
        
        const filteredLeaveData = isAdmin == 1
          ? response?.data.data
          : response?.data?.data.filter(
            (el) => el?.DepartmentId == DepId
          );
        // Call the API
        setLeaveData(filteredLeaveData); 
      } catch (error) {
        console.error("Error fetching leave data:", error);
      } finally {
        setLoading(false); // Stop the loading indicator
      }
    };



    const fetchServiceReq = async () => {
      try {
        const res = await getServiceRequest(UID);
        const detais = isAdmin == 1 ? res.data.data[0] : res.data.data[0].filter((el) => el.DepartmentId == DepId)
        const pendiserviceReq = detais.filter((el) => el.ServiceStatus == 0)
        setAllServices(pendiserviceReq);
      } catch (error) {
        console.error("Error fetching service request", error);
      }
    };

    const gettotaltodayemployee = async () => {
      try {
        const response = await getdutywithdate(payload); // Call the API
        setdutyassignedemployee(response.data.data); // Update the state with the API response
      } catch (error) {
        console.error("Error fetching leave data:", error);
      } finally {
        setLoading(false); // Stop the loading indicator
      }
    };


    const isDefaultTime = (time) => {
      return time === "1900-01-01T00:00:00.000Z" || time === null || time === undefined;
    };


    const getNoWorkingEmployeess = async () => {
      try {
        const response = await getAllEmployee(UID);

        // Filter out non-working employees
        const filter = response.data.data.filter((el) => el.EmpStatusName !== "Working");

        // Further filter by department if the user is not an admin
        const filteredData = isAdmin == 1
          ? filter
          : filter.filter((el) => el.DepartmentId == DepId);

        // Update the state with the filtered data
        setNotWorkingEmployees(filteredData);
      } catch (error) {
        console.error("Error fetching attendance data:", error);
      } finally {
        setLoading(false); // Stop the loading indicator
      }
    };


    const getAttendence = async () => {
      try {
        const response = await getAttendenceData(payload);
        // Check if the user is an admin
        const filteredData = isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter(
            (el) => el?.DEPARTMENTID == DepId
          )

        // Update the state with the filtered data
        setattendancedata(filteredData);
      } catch (error) {
        console.error("Error fetching attendance data:", error);
        // Handle errors if needed, e.g., show a notification or set an error state
      }
      finally {
        setLoading(false); // Stop the loading indicator
      }
    };


    const getAttendenceYesterDay = async () => {
      try {
        setLoading(true); // Start the loading indicator

        // Calculate yesterday's date
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const formattedYesterday = yesterday.toISOString().split("T")[0]; // Format as 'YYYY-MM-DD'

        const data = {
          UserId: UID,
          Date: formattedYesterday, // Use yesterday's date here
        };

        const response = await getAttendenceData(data);

        // Filter the data based on admin status
        const filteredData = isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DEPARTMENTID == DepId);

        // // Count the filtered data
        // const attendanceCount = filteredData?.length;
        // Update the state with the filtered data and count
        setYesterDayattendancedata(filteredData);

const ApprovedUnPunched = filteredData.filter(
  (el) =>
    el.ATTENDANCESTATUS == '1' &&
    (!el.PUNCHIN && !el.PUNCHOUT)
)
        setNoPunchApproved(ApprovedUnPunched)
      } catch (error) {
        console.error("Error fetching attendance data:", error);
        // Handle errors if needed, e.g., show a notification or set an error state
      } finally {
        setLoading(false); // Stop the loading indicator
      }
    };


    const getAttendenceToday = async () => {
      try {
        setLoading(true); // Start the loading indicator

        // Calculate yesterday's date
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate());
        const formattedYesterday = yesterday.toISOString().split("T")[0]; // Format as 'YYYY-MM-DD'

        const data = {
          UserId: UID,
          Date: formattedYesterday, // Use yesterday's date here
        };

        const response = await getAttendenceData(data);

        // Filter the data based on admin status
        const filteredData = isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DEPARTMENTID == DepId);
          setToDayAttenndanceData(filteredData)
       const datas=filteredData.filter((el)=>el.IpAddressOut=='1000'||el.PunchIP=='1000')
        // // Count the filtered data
        // const attendanceCount = filteredData?.length;
        // Update the state with the filtered data and count
        setMobilePunch(datas);
      } catch (error) {
        console.error("Error fetching attendance data:", error);
        // Handle errors if needed, e.g., show a notification or set an error state
      } finally {
        setLoading(false); // Stop the loading indicator
      }
    };








    const isDefaultTimeHead = (time) => {
      return time === "1900-01-01T00:00:00.000Z" || time === null || time === undefined;
    };


    const getTotalHeadCount = async () => {
      try {
        const response = await GetTotalHeadCount(payload);
        console.log(response);
        
        setLastProcess(response?.data?.data[0][0]?.LastPunchProcessedTime);
        // Filter based on admin rights and department
        const filterdAttDep = isAdmin == 1
          ? response?.data?.data[1]
          : response?.data?.data[1].filter(
            (el) => el?.DepartmentId == DepId
          );

        // Filter out entries with valid PUNCHIN or PUNCHOUT
        const filterdAtt = filterdAttDep.filter(
          (el) => !isDefaultTimeHead(el.PUNCHIN) || !isDefaultTimeHead(el.PUNCHOUT)
        );
        setHeadCountData(filterdAtt)

        // Update the state with the filtered headcount
        setheadcount(filterdAtt);
      } catch (error) {
        console.error("Error fetching leave data:", error);
      } finally {
        setLoading(false); // Stop the loading indicator
      }
    };



    const getemployeelist = async () => {
      try {
        const data = {
          UserId: UID,
        };
        const response = await getEmployee(UID);
        // setEndContract(
        //   response.data.data.filter(
        //     (el) => el.ContractEndDate !== null && el.ContractEndDate !== ""
        //   )
        // );
        const filteredEmployee = isAdmin == 1
          ? response?.data?.data : response?.data?.data?.filter(
            (el) => el?.DepartmentId == DepId
          );

        setEndContract(
          filteredEmployee.filter(
            (el) => el.ContractEndDate !== null && el.ContractEndDate !== ""
          )
        );

        setemployeelist(filteredEmployee);

        // Update the state with the API response
      } catch (error) {
        console.error("Error fetching leave data:", error);
      } finally {
        setLoading(false); // Stop the loading indicator
      }
    };

    getemployeelist();
    fetchLeaveData(); // Call the function when the page loads
    gettotaltodayemployee();
    getTotalHeadCount();
    getNoWorkingEmployeess()
    getAttendenceYesterDay()
    getAttendence();
    fetchServiceReq();
    getAttendenceToday()
  }, [UID]);




  const ConstractEndNextMonth = endContract.filter((employee) => {
    if (!employee.ContractEndDate) return false; // Exclude if ContractEndDate is null or undefined

    const contractEndDate = new Date(employee.ContractEndDate);
    const now = new Date();
    const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1); // First day of next month
    const endOfNextMonth = new Date(nextMonth.getFullYear(), nextMonth.getMonth() + 1, 0); // Last day of next month

    // Check if ContractEndDate is within the next month
    return contractEndDate >= nextMonth && contractEndDate <= endOfNextMonth;
  });



  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await getEmployee(UID);
        const filtEmployee = isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter(
            (el) => el?.DepartmentId == DepId
          );

        if (filtEmployee) {
          const filteredEmployees = filtEmployee.filter((el) => el.PayScaleId == null);
          setEmployee(filteredEmployees);
        } else {
          console.error("Invalid response structure:", response);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, [UID]); // Add UID as a dependency if it changes



  const now = new Date(); // Current date
  const fromDate = new Date(now.getFullYear(), now.getMonth(), 2); // First day of the current month
  const toDate = new Date(now.getFullYear(), now.getMonth() + 1); // Last day of the current month



  const fetchData = async () => {
    if (fromDate && toDate) {
      try {
        const payload = {
          option: 'Monthly',
          fromDate: fromDate.toISOString().split('T')[0], // Convert to YYYY-MM-DD format
          toDate: toDate.toISOString().split('T')[0], // Convert to YYYY-MM-DD format
          UserId: UID,
        };

        // Call the API function to get payroll details
        const response = await getPayrollDetails(payload);
        const filteredPayrollData = isAdmin == 1
          ? response?.data?.data[0]
          : response?.data?.data[0]?.filter(
            (el) => el?.DepartmentID == DepId
          );
        // Set payroll data and additions/deductions
        setPayrollData(filteredPayrollData);

      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to fetch payroll data");
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetchCommonDatas = async () => {
      setLoading(true); // Set loading to true when starting the fetch
      try {
        const response = await getProfitCenter(UID);
        setCommonDatas(response.data.data);
      } catch (error) {
        console.error("Error fetching deparments :", error);
      } finally {
        setLoading(false); // Set loading to false once fetch is complete
      }
    };

    fetchCommonDatas();
  }, []);



  const isDefaultTimes = (time) => {
    return time === "1900-01-01T00:00:00.000Z" || time === null || time === undefined;
  };


  const getLeaveGraphData = async () => {
    try {
      const data = {
        UserId: UID,
        currentDate: new Date().toISOString().split('T')[0],
      };
      const resp = await getLeaveGraph(data);
      const filterdGraph = isAdmin == 1 ? resp.data.data : resp.data.data.filter((el) => el.DepartmentId == DepId)
      const filterd = filterdGraph;
      const filterdAtnotPunch = filterd.map((el) => {
        if (el.RecordType === 'Present') {
          // Apply filtering conditions for 'Present' records
          return (isDefaultTimes(el.PUNCHIN) || isDefaultTimes(el.PUNCHOUT)) ? el : null;
        }
        // For other RecordTypes like 'Absent', keep the records as is
        return el;
      }).filter(Boolean); // Remove null values from the array

      setNotPunch(filterdAtnotPunch);
      // Separate logic for filtering 'Present' and leaving 'Absent' untouched
      const filterdAt = filterd.map((el) => {
        if (el.RecordType === 'Present') {
          // Apply filtering conditions for 'Present' records
          return (!isDefaultTimes(el.PUNCHIN) || !isDefaultTimes(el.PUNCHOUT)) ? el : null;
        }
        // For other RecordTypes like 'Absent', keep the records as is
        return el;
      }).filter(Boolean); // Remove null values from the array

      setLeaveGraph(filterdAt);

    } catch (error) {
      console.error("Error fetching leave graph:", error);
    }
  };


  useEffect(() => {
    getLeaveGraphData()
  }, [])



  const isDefaultTimesPro = (time) => {
    return time === "1900-01-01T00:00:00.000Z" || time === null || time === undefined;
  };

  const profitCenterMap = CommonDatas.reduce((acc, item) => {
    acc[item.Id] = item.Name;
    return acc;
  }, {});

  const profitCenterCounts = attendancedata?.reduce((acc, record) => {
    if (!record.ProfitCenterID) {
      return acc;
    }
    acc[record.ProfitCenterID] = acc[record.ProfitCenterID] || 0;
    if (!isDefaultTimesPro(record.PUNCHIN) || !isDefaultTimesPro(record.PUNCHOUT)) {
      acc[record.ProfitCenterID] += 1;
    }
    return acc;
  }, {});


  const categories = Object.keys(profitCenterCounts).map(
    (id) => profitCenterMap[id] || id // Fallback to ID if name is missing
  );
  const data = Object.values(profitCenterCounts);

  const navigate = useNavigate(); // Initialize useNavigate for navigation

useEffect(() => {
  if (!attendancedata || attendancedata.length === 0) {
    setLateEmployees([]);
    return;
  }

  // 🔹 Convert datetime to total minutes (UTC-safe)
  const getTimeInMinutes = (dateString) => {
    if (!dateString || dateString === null || dateString === undefined) return null;
    const date = new Date(dateString);
    // Check if date is valid
    if (isNaN(date.getTime())) return null;
    return date.getUTCHours() * 60 + date.getUTCMinutes();
  };

  // 🔹 Check if employee is late
  const isLateArrival = (row) => {
    // Robust null/undefined/empty check for PUNCHIN
    if (!row.PUNCHIN || row.PUNCHIN === null || row.PUNCHIN === undefined) {
      return false;
    }
    
    // Check if StartTime exists
    if (!row.StartTime || row.StartTime === null || row.StartTime === undefined) {
      return false;
    }

    const gracePeriod = parseInt(row.GracePeriod) || 0;
    const punchInMinutes = getTimeInMinutes(row.PUNCHIN);
    const startTimeMinutes = getTimeInMinutes(row.StartTime);

    // Additional safety check - if conversion failed
    if (punchInMinutes === null || startTimeMinutes === null) {
      return false;
    }

    return punchInMinutes > startTimeMinutes + gracePeriod;
  };

  // 🔹 Calculate late time (HH:mm)
  const calculateLateTime = (row) => {
    if (!row.PUNCHIN || row.PUNCHIN === null || row.PUNCHIN === undefined) return "-";
    if (!row.StartTime || row.StartTime === null || row.StartTime === undefined) return "-";

    const gracePeriod = parseInt(row.GracePeriod) || 0;
    const punchInMinutes = getTimeInMinutes(row.PUNCHIN);
    const startTimeMinutes = getTimeInMinutes(row.StartTime);

    // Safety check
    if (punchInMinutes === null || startTimeMinutes === null) return "-";

    const allowedStartMinutes = startTimeMinutes + gracePeriod;

    if (punchInMinutes <= allowedStartMinutes) return "-";

    const lateMinutes = punchInMinutes - allowedStartMinutes;
    const hours = Math.floor(lateMinutes / 60);
    const minutes = lateMinutes % 60;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
  };

  // 🔹 Filter late employees - only include those with valid punch-in data
  const late = attendancedata.filter((employee) => {
    // First filter: Must have PUNCHIN data
    if (!employee.PUNCHIN || employee.PUNCHIN === null || employee.PUNCHIN === undefined) {
      return false;
    }
    // Second filter: Must be actually late
    return isLateArrival(employee);
  });

  console.log('Late employees:', late);
  console.log('Total late count:', late.length);

  // Attach late time info
  const lateWithTime = late?.map((e) => ({
    ...e,
    LateBy: calculateLateTime(e),
  }));

  setLateEmployees(lateWithTime);
}, [attendancedata]);

  useEffect(() => {
    setLateEmp(lateEmployees)
  }, [lateEmployees])

  useEffect(() => {
    setContract(ConstractEndNextMonth)
  }, [employee])


const profitCenterStats = LeveGraph?.reduce((acc, item) => {
  const profitCenter = item?.ProfitcenterName || "Unknown";
  const recordType = item?.RecordType || "Unknown";

  if (!acc[profitCenter]) {
    acc[profitCenter] = { Present: 0, Leave: 0 };
  }

  if (recordType === "Present") {
    acc[profitCenter].Present += 1;
  } else if (recordType === "Leave") {
    acc[profitCenter].Leave += 1;
  }

  return acc;
}, {}) || {};

// Build NoPunch aggregation from today's attendance
const noPunchStats = toDayAttenndanceData?.reduce((acc, item) => {
  const profitCenter = item?.ProfitcenterName || "Unknown";

  if (!acc[profitCenter]) {
    acc[profitCenter] = 0;
  }

  // Count as NoPunch if both PUNCHIN & PUNCHOUT are null
  if (!item?.PUNCHIN && !item?.PUNCHOUT) {
    acc[profitCenter] += 1;
  }

  return acc;
}, {}) || {};

// Extract categories
const profitCenterNames = Array.from(
  new Set([
    ...Object.keys(profitCenterStats),
    ...Object.keys(noPunchStats),
  ])
);

const presentCounts = profitCenterNames.map(pc => profitCenterStats[pc]?.Present || 0);
const leaveCounts   = profitCenterNames.map(pc => profitCenterStats[pc]?.Leave || 0);
const noPunchCounts = profitCenterNames.map(pc => noPunchStats[pc] || 0);

// Handle empty case
if (!profitCenterNames.length) {
  profitCenterNames.push("No Data");
  presentCounts.push(0);
  leaveCounts.push(0);
  noPunchCounts.push(0);
}


  const chartDataLeave = {
    series: [
      { name: "Present", data: presentCounts },
      { name: "Leave", data: leaveCounts },
      { name: "NO Punch", data: noPunchCounts },
    ],
    options: {
      chart: {
        type: "bar",
        stacked: false, // Set to true for stacked bars, false for grouped bars
        toolbar: { show: false },
        animations: {
          enabled: true,
          easing: "easeinout",
          speed: 800,
        },
        events: {
          dataPointSelection: (event, chartContext, config) => {
            const selectedProfitCenter = profitCenterNames[config.dataPointIndex];
            let selectedSeries;

            if (config.seriesIndex === 0) {
              selectedSeries = "Present";
              navigate("/Present", {
                state: {
                  TotalHeadcount: HeadCountData, selectedProfitCenter // Add ProfitcenterName to state
                }
              });
            } else if (config.seriesIndex === 1) {
              selectedSeries = "Leave";
              navigate("/TodayLeave", { state: { ApprovedLeaves, selectedProfitCenter } });
            } else {
              selectedSeries = "No Punch";
              navigate("/NoPunch", { state: { selectedProfitCenter } });
            }
          },

          mouseMove: (event, chartContext, config) => {
            if (config?.dataPointIndex !== undefined) {
              event.target.style.cursor = "pointer";
            } else {
              event.target.style.cursor = "default";
            }
          },
        },
      },
      colors: ["#00E396", "#FF4560", "#dbd935"], // Changed No Punch color to blue
      xaxis: {
        categories: profitCenterNames, // ProfitcenterName values
        labels: {
          style: {
            fontFamily: "Arial",
            fontSize: "12px",
          },
        },
        axisBorder: {
          show: true,
          color: "#78909C",
        },
        axisTicks: {
          show: true,
          color: "#78909C",
        },
      },
      yaxis: {
        title: {
          text: "Number of Employees",
          style: {
            fontSize: "12px",
            fontWeight: 600,
          },
        },
        min: 0,
        max: Math.max(
          ...presentCounts,
          ...leaveCounts,
          ...noPunchCounts,
          5
        ) + 2, // Dynamic max with buffer
        tickAmount: 5,
        labels: {
          formatter: (value) => Math.round(value),
          style: {
            fontSize: "11px",
          },
        },
        crosshairs: {
          show: true,
          position: "back",
          stroke: {
            color: "#B0BEC5",
            width: 1,
            dashArray: 0,
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (value) => (value > 0 ? Math.round(value) : ""), // Show only non-zero values
        style: {
          fontSize: "12px",
          fontFamily: "Arial",
          colors: ["#000"],
        },
        background: {
          enabled: false,
        },
        dropShadow: {
          enabled: false,
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "center",
        fontSize: "13px",
        markers: {
          width: 12,
          height: 12,
          radius: 12,
        },
        itemMargin: {
          horizontal: 10,
          vertical: 5,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "30%", // Adjust for grouped bars
          borderRadius: 4,
          distributed: false,
          dataLabels: {
            position: "top",
          },
        },
      },
      tooltip: {
        enabled: true,
        shared: true,
        intersect: false,
        style: {
          fontSize: "12px",
        },
        y: {
          formatter: (value) => (value > 0 ? `${Math.round(value)} employees` : "0 employees"),
          title: {
            formatter: (seriesName) => seriesName,
          },
        },
        marker: {
          show: true,
        },
      },
      states: {
        hover: {
          filter: {
            type: "lighten",
            value: 0.05,
          },
        },
        active: {
          filter: {
            type: "darken",
            value: 0.2,
          },
        },
      },
      grid: {
        show: true,
        borderColor: "#ECEFF1",
        strokeDashArray: 0,
        position: "back",
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              height: 300,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  };

  const chartData = {
    series: [
      {
        name: "Employees",
        data: data, // Object.values(profitCenterCounts)
      },
    ],
    options: {
      chart: {
        type: "bar",
        stacked: false,
        toolbar: { show: false },
        events: {
          dataPointSelection: (event, chartContext, config) => {
            const selectedProfitCenter = categories[config.dataPointIndex];
            navigate("/Present", {
              state: {
                selectedProfitCenter,
                TotalHeadcount: HeadCountData
              }
            });
          },
          mouseMove: (event, chartContext, config) => {
            if (config?.dataPointIndex !== undefined) {
              event.target.style.cursor = "pointer";
            } else {
              event.target.style.cursor = "default";
            }
          },
        },
      },
      colors: ["#3498db"],
      xaxis: {
        categories: categories, // Profit center names
        labels: { style: { fontFamily: "Arial" } },
      },
      yaxis: {
        title: { text: "Number of Employees" },
      },
      dataLabels: { enabled: false },
      legend: { position: "top" },
      plotOptions: {
        bar: {
          distributed: false,
          borderRadius: 4,
          columnWidth: "70%",
        },
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val) {
            return val + " employees";
          },
        },
      },
    },
  };


 

  // Get current date
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const day = String(currentDate.getDate()).padStart(2, '0');
  const formattedDate = `${day}-${month}-${year}`;
  const formattedDateTime = `${lastProcess?.slice(8, 10)}-${lastProcess?.slice(5, 7)}-${lastProcess?.slice(0, 4)} , ${lastProcess?.slice(11, 16)}`;
  const pendingAttendance = attendancedata?.filter((el) => el.ATTENDANCESTATUS === 0);
  const pendingLeave = leaveData.filter((el) => el.Status === 0);
  const uncheckedPayrollData = PayrollData?.filter((el) => el.IsChecked === 0 || !el.IsChecked);
  const ApprovedLeaves = leaveData.filter((el) => {
    const currentDate = new Date();
    const startDate = new Date(el.StartDate);
    const endDate = new Date(el.EndDate);
    const isWithinRange =
      currentDate.toISOString().split("T")[0] >= startDate.toISOString().split("T")[0] &&
      currentDate.toISOString().split("T")[0] <= endDate.toISOString().split("T")[0];
    return el.Status === 1 && isWithinRange;
  });


  return (
    <>
      <Breadcrumb title="HR Dashboard" path="HR Dashboard" />
      <div className="flex items-center space-x-2 text-gray-700">
        <span className="font-medium">Last Punch Process Time:</span>
        <span className="text-indigo-600 font-semibold">{formattedDateTime}</span>
      </div>
     

      <div className="grid md:grid-cols-12 grid-cols-1 gap-30 mb-30">
        <div className="xxl:col-span-3 md:col-span-6 bg-bg-dark rounded-lg shadow-light">
          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link
                to="/Present"
                state={{ TotalHeadcount: HeadCountData }}
              >
                <IconUser />
              </Link>
            </div>
            <div>
              <p>Total Head count</p>
              <p className="text-[20px]/[24px] font-medium">
                {/* {headcount?.length || 0} */}
                {headcount.length}
              </p>
            </div>
          </div>


<div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
             <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link
                to="/mobilePunchreport"
                state={{ MobilePunch: MobilePunch }}
              >
                <IconPhone />
              </Link>
            </div>
            <div>
              <p>Mobile Punches</p>
              <p className="text-[20px]/[24px] font-medium">
                {/* {headcount?.length || 0} */}
                {MobilePunch.length}
              </p>
            </div>
          </div>

           <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link
                to="ApprovedNoPunch"
                state={{ NoPunchApproved: NoPunchApproved }}
              >
                <IconCheck />
              </Link>            </div>
            <div>
              <p>AttendanceApproved NoPunches (Yesterday)</p>
              <p className="text-[20px]/[24px] font-medium">
                {NoPunchApproved?.length}
              </p>
            </div>
          </div>

          
          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link
                to="TodayLeave"
                state={{ ApprovedLeaves }}
              >
                <IconUsersGroup />
              </Link>
            </div>
            <div>
              <p>Employees On Leave Today</p>
              <p className="text-[20px]/[24px] font-medium">
                {
                  leaveData.filter((el) => {
                    const currentDate = new Date();
                    const startDate = new Date(el.StartDate);
                    const endDate = new Date(el.EndDate);

                    // Compare only the date parts to avoid time zone issues
                    const isWithinRange =
                      currentDate.toISOString().split("T")[0] >= startDate.toISOString().split("T")[0] &&
                      currentDate.toISOString().split("T")[0] <= endDate.toISOString().split("T")[0];

                    return el.Status === 1 && isWithinRange;
                  })?.length || 0
                }
              </p>
            </div>
          </div>
          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link to={'WorkingEmployees'}><IconUsersGroup /></Link>
            </div>
            <div>
              <p>Total No of Employee (Working)</p>
              <p className="text-[20px]/[24px] font-medium">
                {employeelist.length || 0}
              </p>
            </div>
          </div>
          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link to={'NonWorkingEmployees'}><IconUsersGroup /></Link>
            </div>
            <div>
              <p>Total No of Employee (Not Working)</p>
              <p className="text-[20px]/[24px] font-medium">
                {NotWorkingEmployees.length || 0}
              </p>
            </div>
          </div>


          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link to={'employee'} state={{ notfinanceemployee: employee }}>
                <IconCash />
              </Link>
            </div>
            <div>
              <p> <p>Employee Finance Master Not Entered</p></p>
              <p className="text-[20px]/[24px] font-medium">
                {employee?.length || 0}
              </p>
            </div>
          </div>

          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link to={'/LateEmp'}><IconUsersGroup /></Link>
            </div>
            <div>
              <p>Late Employees</p>
              <p className="text-[20px]/[24px] font-medium">
                {lateEmployees?.length}
              </p>
            </div>

          </div>

          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link to={'/ContractEnd'}><IconUsersGroup /></Link>
            </div>
            <div>
              <p>Contract Ending On Next Month</p>
              <p className="text-[20px]/[24px] font-medium">
                {ConstractEndNextMonth?.length}
              </p>
            </div>

          </div>






        </div>
        <div className="xxl:col-span-3 md:col-span-6 bg-bg-dark rounded-lg shadow-light">
          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <IconClock />
            </div>
            <div>
              <b className="text-xl">Approval Pending</b>
            </div>
          </div>
          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link
                to="PendingLeave"
                state={{ pendingLeave }} // Pass the filtered data as state
              >
                <IconBell />
              </Link>            </div>
            <div>
              <p>Leave Request Approval</p>
              <p className="text-[20px]/[24px] font-medium">
                {leaveData.filter((el) => el.Status == 0)?.length || 0}
              </p>
            </div>
          </div>
          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link
                to="AttendancePending"
                state={{ pending: pendingAttendance }}
              >
                <IconBell />
              </Link>            </div>
            <div>
              <p>Attendance Approval  Yesterday</p>
              <p className="text-[20px]/[24px] font-medium">
                {YesterDayattendancedata?.filter((el) => el.ATTENDANCESTATUS == 0 && el.EmployeeStatus == "Working")
                  ?.length || 0}
              </p>
            </div>
          </div>

         


          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link
                to="ServiceRequest-permission"
                state={{ pending: allServices }}
              >
                <IconBell />
              </Link>            </div>
            <div>
              <p>All Pending Service Requests and Permissions
              </p>
              <p className="text-[20px]/[24px] font-medium">
                {allServices?.length || 0}
              </p>
            </div>
          </div>

          <div className="md:p-20 p-15 flex items-center gap-15 border-b border-border last:border-none">
            <div className="flex items-center justify-center w-50 h-50 rounded-lg border border-border">
              <Link
                to="Payrollpending"
                state={{ uncheckedPayrollData }} // Pass the filtered data as state
              >
                <IconMoneybag />
              </Link>         </div>
            <div>
              <p>Payroll Approval On This Month</p>
              <p className="text-[20px]/[24px] font-medium">
                {PayrollData?.filter((el) => el.IsChecked == 0 || !el.IsChecked).length || 0}


              </p>

            </div>
          </div>



        </div>

        <div className="xxl:col-span-6 md:col-span-12 bg-bg-dark rounded-lg shadow-light">
          <div className="bg-bg-dark rounded-lg shadow-light p-5">
            <h2 className="text-lg font-medium mb-4">Attendance Statistics on {formattedDate}</h2>
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="bar"
              height={300}
            />
          </div>
        </div>

        <div className="w-full col-span-12 bg-bg-dark rounded-lg shadow-light">
          <div className="bg-bg-dark rounded-lg shadow-light p-5">
            <h2 className="text-lg font-medium mb-4">  Employee Statistics on {formattedDate}</h2>
            <div style={{ width: '100%', height: '400px' }}>
              <ReactApexChart
                options={chartDataLeave.options}
                series={chartDataLeave.series}
                type="bar"
                height="100%"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
